// ADR 0001 §5 - native-only storage for the long-lived opaque api_token.
// Comment: ADR §5 calls for Keychain on mobile; Preferences matches the app's
// existing credential storage - swap the backend here when a secure-storage
// plugin is adopted.
import { Capacitor } from "@capacitor/core"
import { Preferences } from "@capacitor/preferences"

const KEY = "api_token"

export const TokenVault = {
  async get() {
    if (!Capacitor.isNativePlatform()) return null
    const { value } = await Preferences.get({ key: KEY })
    return value || null
  },
  async set(token) {
    if (!Capacitor.isNativePlatform()) return null
    await Preferences.set({ key: KEY, value: token })
  },
  async clear() {
    if (!Capacitor.isNativePlatform()) return null
    await Preferences.remove({ key: KEY })
  },
}

export default TokenVault
